// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2GUFv","content":"styles_content__24abM","selectAll":"styles_selectAll__cLp6X"};